export const isGamePage = (page) => {
  return page === '/'
}
